(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsroom-article-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root) return;
      if (root.getAttribute('data-newsroom-article-init') === '1') return;
      root.setAttribute('data-newsroom-article-init', '1');

      var article = root.querySelector('.newsroom-article');
      var btnTop = root.querySelector('[data-newsroom-scroll-top]');
      var btnBack = root.querySelector('[data-newsroom-go-back]');
      var fab = root.querySelector('.newsroom-article__fab');
      var mainScroller = null;

      var rafFooter = 0;
      var BASE_BOTTOM = 80;

      function setFabBottom(px) {
        if (!fab) return;
        fab.style.setProperty('--newsroom-fab-bottom', String(Math.max(0, Math.ceil(px))) + 'px');
      }

      function updateTopGradientHeight() {
        if (!article) return;
        var h = article.getBoundingClientRect().height || 0;
        if (h <= 0) return;
        root.style.setProperty('--newsroom-article-gradient-height', String(Math.round(h * 0.3)) + 'px');
      }

      function resolveFooter() {
        return (
          document.querySelector('.beambox-footer') ||
          document.querySelector('footer') ||
          document.querySelector('.shopify-section-footer') ||
          document.querySelector('[class*="footer" i]')
        );
      }

      function resolveMainScroller() {
        var candidates = [document.getElementById('MainContent'), document.querySelector('main')];
        for (var i = 0; i < candidates.length; i += 1) {
          var el = candidates[i];
          if (!el) continue;
          // If it can actually scroll, treat it as the scroller.
          if (el.scrollHeight > el.clientHeight + 2) return el;
          try {
            var cs = window.getComputedStyle(el);
            var oy = cs && cs.overflowY;
            if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight >= el.clientHeight) return el;
          } catch (e) {
            // ignore
          }
        }
        return null;
      }

      function getScrollY() {
        var wy = window.scrollY || window.pageYOffset || 0;
        var hy = (document.documentElement && document.documentElement.scrollTop) || 0;
        var by = (document.body && document.body.scrollTop) || 0;
        var my = mainScroller ? mainScroller.scrollTop || 0 : 0;
        return Math.max(wy, hy, by, my);
      }

      function scrollToTop() {
        // Some themes scroll inside #MainContent; calling all is safe.
        try {
          if (mainScroller) mainScroller.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (e) {
          if (mainScroller) mainScroller.scrollTop = 0;
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (document.documentElement) document.documentElement.scrollTop = 0;
        if (document.body) document.body.scrollTop = 0;
      }

      function updateFabAvoidFooter() {
        rafFooter = 0;
        if (!fab) return;
        var footer = resolveFooter();
        if (!footer) {
          setFabBottom(BASE_BOTTOM);
          return;
        }

        var rect = footer.getBoundingClientRect();
        // When footer enters viewport, lift FAB above it.
        var overlap = window.innerHeight - rect.top;
        if (overlap > 0) {
          setFabBottom(BASE_BOTTOM + overlap);
        } else {
          setFabBottom(BASE_BOTTOM);
        }
      }

      function scheduleFabAvoidFooter() {
        if (rafFooter) return;
        rafFooter = window.requestAnimationFrame(updateFabAvoidFooter);
      }

      function setTopVisibility() {
        if (!btnTop) return;
        var y = getScrollY();
        if (y > 420) {
          btnTop.classList.add('is-visible');
        } else {
          btnTop.classList.remove('is-visible');
        }
      }

      function press(el) {
        if (!el) return;
        el.classList.add('is-pressed');
        window.setTimeout(function () {
          el.classList.remove('is-pressed');
        }, 160);
      }

      if (btnTop) {
        btnTop.addEventListener(
          'click',
          function () {
            press(btnTop);
            scrollToTop();
          },
          { passive: true }
        );
      }

      if (btnBack) {
        btnBack.addEventListener(
          'click',
          function () {
            press(btnBack);
            if (window.history && window.history.length > 1) {
              window.history.back();
            } else {
              var href = '';
              try {
                href = String(btnBack.getAttribute('data-newsroom-back-href') || '').trim();
              } catch (e) {
                href = '';
              }
              window.location.href = href || '/';
            }
          },
          { passive: true }
        );
      }

      mainScroller = resolveMainScroller();

      function onScrollOrResize() {
        setTopVisibility();
        scheduleFabAvoidFooter();
      }

      updateTopGradientHeight();
      setTopVisibility();
      updateFabAvoidFooter();

      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener(
        'resize',
        function () {
          mainScroller = resolveMainScroller();
          updateTopGradientHeight();
          onScrollOrResize();
        },
        { passive: true }
      );

      if (mainScroller) {
        mainScroller.addEventListener('scroll', onScrollOrResize, { passive: true });
      }

      // Footer may be rendered after this section; re-check once fully loaded.
      window.addEventListener('load', onScrollOrResize, { once: true });
      window.setTimeout(onScrollOrResize, 50);
      window.setTimeout(onScrollOrResize, 300);
      window.setTimeout(updateTopGradientHeight, 50);
      window.setTimeout(updateTopGradientHeight, 300);
    }

    function boot() {
      var roots = document.querySelectorAll('.newsroom-article-page-section');
      if (!roots || !roots.length) return;
      for (var i = 0; i < roots.length; i += 1) init(roots[i]);
    }

    boot();
    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      if (event.target.classList && event.target.classList.contains('newsroom-article-page-section')) {
        init(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
